import React from "react";

import { useFormikContext } from "formik";

import { Box, Divider, Grid, GridItem, Text } from "@chakra-ui/react";

import { Group } from "../../Group";
import { CustomInputWField } from "../../../../../components/CustomInputWField";
import { RadioOptions } from "../../RadioOptions";

export const PossuiNumero = () => {
  const { values, errors, touched } = useFormikContext();

  return (
    <Group>
      <Text
        mt="5"
        mb="2"
        fontWeight={700}
        fontSize="16px"
        lineHeight="21.6px"
        color="#169499">
        NÚMERO DE IDENTIFICAÇÃO SOCIAL
      </Text>
      <Divider mb="5" />
      <RadioOptions
        label="Possui Número de Identificação Social?*"
        fieldName="possuiNumeroIdentidadeSocial"
        errors={errors}
        touched={touched}
      />
      {values.possuiNumeroIdentidadeSocial === "S" && (
        <Grid
          mt="15px"
          templateColumns="repeat(2, 1fr)"
          gap="25px"
          rowGap="20px">
          <GridItem colSpan={{ base: 2, sm: 2, lg: 1 }}>
            <Box width={{ lg: "450.48px" }}>
              <CustomInputWField
                fieldName="numeroIdentidadeSocial"
                label="Número de Identificação Social*"
                placeholder="Informe o Número de Identificação Social"
                whiteSpace={true}
              />
            </Box>
          </GridItem>
        </Grid>
      )}
    </Group>
  );
};
